const EVENTS = {
    main: {
        margin: 0,
        padding: 0,
        listStyle: 'none'
    },
    // badge: {
    //     width: '100 %',
    //     overflow: 'hidden',
    //     fontSize: 12,
    //     whiteSpace: 'nowrap',
    //     textOverflow: 'ellipsis'
    // }
    view: {
        display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', alignContent: 'center', marginBottom: 4, padding: 4, gap: 4
    },
    itemName: {
        fontSize: 12,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    itemTime: {
        fontSize: 9, 
        textAlign: 'right', 
        whiteSpace: 'nowrap'
    }
}

const NOTES = {
    month: {
        fontSize: 28,
        textAlign: 'center',
    },
    monthSection: {
        fontSize: 28,
    }
}

export { EVENTS, NOTES }